import { Edit } from 'lucide-react';
import { Button, Eyebrow } from '@/shared/components';

interface Props {
  channexPropertyId: string | null | undefined;
  canOpenMapping: boolean;
  canConnectBookingCom: boolean;
  openingMapping: boolean;
  onOpenMapping: () => void;
  onConnectBookingCom: () => void;
}

export function ChannelsTabHeader({
  channexPropertyId,
  canOpenMapping,
  canConnectBookingCom,
  openingMapping,
  onOpenMapping,
  onConnectBookingCom,
}: Props) {
  return (
    <header className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div className="min-w-0">
        <Eyebrow>Kanäle</Eyebrow>
        <h2 className="text-ink mt-3 font-serif text-3xl font-normal tracking-tight">
          Verbundene <span className="font-serif-italic">Buchungsportale</span>
          <span className="text-sealwax">.</span>
        </h2>
        <p className="text-ink-soft mt-2 max-w-prose text-sm">
          Die Zuordnung der Zimmer und Raten läuft im Fenster des Kanalmanagers. Darunter steht, was
          aktuell verbunden ist.
        </p>
        {/*
          Ein Kanal hängt am Objekt, nicht am Apartment: alle Apartments eines Objekts teilen sich
          dieselbe Property beim Kanalmanager. Verbinden und Trennen wirken deshalb auf jedes
          Geschwister mit — das muss dranstehen, sonst liest sich die Fläche als Apartment-Aktion.
        */}
        <p className="text-ink-faint mt-1 max-w-prose text-xs">
          Kanäle gehören dem <strong>Objekt</strong>: Verbinden und Trennen wirken auf alle
          Apartments dieses Objekts, nicht nur auf dieses.
        </p>
      </div>
      {channexPropertyId && (
        <div className="flex flex-wrap items-center gap-2">
          {canOpenMapping && (
            <Button
              variant="primary"
              size="sm"
              loading={openingMapping}
              leftIcon={<Edit size={13} strokeWidth={2} aria-hidden />}
              onClick={onOpenMapping}
            >
              Mapping öffnen
            </Button>
          )}
          {canConnectBookingCom && (
            <Button variant="brand" size="sm" onClick={onConnectBookingCom}>
              Booking.com verbinden
            </Button>
          )}
        </div>
      )}
    </header>
  );
}
